import toast from "react-hot-toast";
import { Get } from "../../../../Request";

export const GetData = async (pay) => {
    return await Get({
      url: "/order/Tickets",
      data: {
        paykey: pay,
      },
    }).then((data) => {
      return data;
    });
  };